import { z } from 'zod/v4';

/** What `POST /api/admin/files/chat-with-file` takes: a question about one file. */
export const ChatWithFileBodySchema = z.object({
  fileId: z.string().min(1),
  message: z.string().min(1),
});

export type ChatWithFileBody = z.infer<typeof ChatWithFileBodySchema>;

/** The model's answer about the file, with the question it answers. */
export const ChatWithFileResponseSchema = z.object({
  fileId: z.string(),
  question: z.string(),
  response: z.string(),
});

export type ChatWithFileResponse = z.infer<typeof ChatWithFileResponseSchema>;
